<template>
  <div class="card" style="margin-bottom: 10px;">
    <div class="cardBody">
      <div class="cardContent">
        <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: flex-start;">
          <p class="cardTitleType1" style="margin: 0px">{{ tajukKad }}</p>
          <!-- <div style="display: flex; flex-direction: row; justify-content: flex-end; align-items: center; flex: 1;">
            <el-button @click="()=>personalExcel()" type="success smaller"><i class="el-icon-document" style="margin-right: 5px;"/>EXCEL</el-button>
          </div> -->
        </div>
        <div style="display: flex; flex-direction: column; width: 100%; justify-content: flex-start; align-items: flex-start;">
          <p style="margin-bottom: 0px;">Jenis Akaun : <span style="font-weight: bold;">{{ profileVehicleType | formatProfileVehicleType }}</span></p>
          <p style="margin-bottom: 0px; font-weight: bold;">Kuota Subsidi Semasa Bulan : {{ currentMonthLabel }}</p> 
          <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center; width: 100%; margin-top: 0px;">
            <!-- <p v-if="registerForm.fleetcardSubmittedFlagEhailing" style="margin-bottom: 0px;">Jumlah Kuota Bulan (Semasa) : <span style="font-weight: bold;">{{ kenderaanKuotaAsa }} Liter</span></p> -->
            <!-- <p style="font-weight: bold; margin-top: 0px; margin-bottom: 0px; margin-right: 10px;">Carian No. Pendaftaran Kenderaan:</p>
            <el-input
              style="width: 240px;"
              v-model="searchKenderaan">
            </el-input> -->
          </div>
          <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center; width: 100%; margin-top: 20px;">
            <!-- <el-button style="padding: 10px 24px;" @click="()=>selectAll()" type="primary" v-if="rayuanless === false">
              Pilih Semua
            </el-button> -->
            <!-- <el-button style="padding: 10px 24px;" @click="()=>saveAndNavigate('fleetcard/mulatambahkenderaan')" type="primary" v-if="rayuanless === false">
              <i class="el-icon-plus" style="margin-right: 5px;"/> Rayuan
            </el-button> -->
          </div>
          <div
            v-for="tableSection in vehicleTableSections"
            :key="tableSection.key"
            style="width: 100%;"
          >
            <p
              v-if="tableSection.showTitle"
              class="cardTitleType1"
              style="margin: 30px 0px 10px 0px;"
            >
              {{ tableSection.title }}
            </p>
            <el-table
              :default-sort="{ prop: 'name', order: 'descending' }"
              :data="tableSection.vehicles"
              v-loading.body="loading"
              element-loading-text="Loading"
              @sort-change="sortChange"
              :row-class-name="getRowClassName"
              fit
              highlight-current-row
            >
          <!-- @row-click="rowClick"
            row-class-name="rowClickable" -->
            <el-table-column
              label="No."
              width="50" type="index" :index="indexMethod">
            </el-table-column>
            <el-table-column
              label="#"
              width="50" type="index">
              <template slot-scope="scope">
                <!-- <el-checkbox v-if="!checkboxLoading" :disabled="(scope.row.vehicleActiveTickedFlag && registerForm.fleetcardSubmittedFlagEhailing) || tickedless || getVehicleStatusValue(scope.row) === false" v-model="scope.row.vehicleActiveTickedFlag" @change="()=>toggleVehicleTicked(scope.row, true)"></el-checkbox> -->
                <el-checkbox v-if="!checkboxLoading" disabled v-model="scope.row.vehicleActiveTickedFlag" @change="()=>toggleVehicleTicked(scope.row, true)"></el-checkbox>
                <i v-else class="el-icon-loading" style="font-size: 20px; color: var(--primary5-color);"></i>
              </template>
            </el-table-column>
            <!-- <el-table-column label="Tindakan" width="80">
              <template slot-scope="scope">
                <el-button
                  v-if="!locked"
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  style="margin-left: 0px;"
                  @click="handleVehicleDelete(scope.$index, scope.row)"
                ></el-button>
              </template>
            </el-table-column> -->
            <el-table-column
              label="Status Kenderaan"
              width="200" type="index">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span v-if="scope.row.vehicleRestrictionFlag" class="lh12" style="color: #990000;">KENDERAAN DISEKAT</span>
                  <span v-else class="lh12" :style="getVehicleStatusValue(scope.row) === false ? 'color: #990000;' : 'color: #009900;'">
                    {{ getVehicleStatusLabel(scope.row) }}
                  </span>
                  <!-- <template v-if="getVehicleStatusValue(scope.row) === false">
                    <template v-if="scope.row.vehicleAppealResponse === 'rejected'">
                      <span class="lh12" style="margin-top: 10px; color: #990000;">
                        RAYUAN GAGAL
                        <a class="fileLink" style="font-size: 12px; margin: 0px;" @click="readMoreDialog(scope.row)">Lihat lagi</a>
                      </span>
                    </template>
                    <template v-else>
                      <span class="lh12" style="margin-top: 10px; color: var(--darker-border-color);" v-if="scope.row.vehicleAppealFlag">
                        RAYUAN DALAM PROSES
                      </span>
                      <el-button v-else-if="rayuanless === false" type="primary smaller" @click="()=>viewRayuan(scope.$index, scope.row)" style="margin-left: 5px; margin-top: 10px;">
                        <i class="el-icon-plus"/> Rayuan
                      </el-button>
                    </template>
                  </template> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="vehicleNumber"
              label="No. Pendaftaran Kenderaan"
              width="140"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span style="word-break: break-word;">{{ scope.row.vehicleNumber }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="vehiclebodytypeId"
              label="Sektor Pengangkutan"
              width="140"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span style="word-break: break-word;">{{ scope.row.vehiclebodytypeId && scope.row.vehiclebodytypeId.bodytypeSector ? scope.row.vehiclebodytypeId.bodytypeSector === 'awam' ? 'AWAM' : scope.row.vehiclebodytypeId.bodytypeSector === 'barangan' ? 'BARANGAN' : scope.row.vehiclebodytypeId.bodytypeSector : scope.row.vehicleBodyTypeSector ? scope.row.vehicleBodyTypeSector : '-' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="vehiclebodytypeId"
              label="Jenis Badan"
              width="240"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <!-- <span style="word-break: break-word;">{{ scope.row.vehiclebodytypeId ? `(${scope.row.vehiclebodytypeId.bodytypeCode}) - ${scope.row.vehiclebodytypeId.bodytypeName}` : '-' }}</span> -->
                  <span style="word-break: break-word;">{{ scope.row.vehicleBodyTypeName ? `${scope.row.vehicleBodyTypeCode ? `(${scope.row.vehicleBodyTypeCode}) - `  : ''}${scope.row.vehicleBodyTypeName}` : scope.row.vehicleBodyTypeCode ? `${scope.row.vehicleBodyTypeCode}` : '-' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="vehiclemodeltypeId"
              label="Kelas Kegunaan"
              width="240"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <!-- <span style="word-break: break-word;">{{ scope.row.vehiclemodeltypeId ? `(${scope.row.vehiclemodeltypeId.modeltypeCode}) - ${scope.row.vehiclemodeltypeId.modeltypeName}` : '-' }}</span> -->
                  <span style="word-break: break-word;">{{ scope.row.vehicleModelTypeName ? `${scope.row.vehicleModelTypeCode ? `(${scope.row.vehicleModelTypeCode}) - `  : ''}${scope.row.vehicleModelTypeName}` : scope.row.vehicleModelTypeCode ? `${scope.row.vehicleModelTypeCode}` : '-' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="vehicleRoadTaxEndDate"
              label="Tarikh Tamat Cukai Jalan"
              width="160"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span style="word-break: break-word;">{{ scope.row.vehicleRoadTaxEndDate | formatDate }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="vehiclemodeltypeId"
              label="Kawasan Isytihar"
              width="180"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span style="word-break: break-word;">{{ scope.row.vehicleDeclarationArea ? `${scope.row.vehicleDeclarationArea}` : '' }}</span>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="vehiclePermitEndDate"
              label="Tarikh Tamat Permit"
              width="160"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span style="word-break: break-word;">{{ scope.row.vehiclePermitEndDate | formatDate }}</span>
                </div>
              </template>
            </el-table-column> -->
            <!-- <el-table-column
              prop="vehiclePermitEndDate"
              label="Tarikh Permohonan"
              width="160"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span style="word-break: break-word;">{{ scope.row.createdAt | formatDate }}</span>
                </div>
              </template>
            </el-table-column> -->
            <el-table-column
              prop="vehicleQuotaBase"
              label="Kuota Asas (Liter)"
              width="160"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span v-if="(scope.row.vehiclebodytypeId && scope.row.vehiclebodytypeId.bodytypeSector && scope.row.vehiclebodytypeId.bodytypeSector === 'barangan' && (!revealBaranganQuota || (hideBorneolabuanBaranganQuota && isTrioDeclarationArea(scope.row))))">-</span>
                  <span v-else style="word-break: break-word;">{{ scope.row.vehicleQuotaBase | formatNumber }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="vehicleQuotaBreakdown"
              label="Kuota Pecahan (Liter)"
              width="180"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; width: 100%;">
                  <span v-if="(scope.row.vehiclebodytypeId && scope.row.vehiclebodytypeId.bodytypeSector && scope.row.vehiclebodytypeId.bodytypeSector === 'barangan' && (!revealBaranganQuota || (hideBorneolabuanBaranganQuota && isTrioDeclarationArea(scope.row))))">-</span>
                  <template v-else-if="scope.row.vehicleQuotaBase === 0">-</template>
                  <template v-else>
                    <div
                      v-for="(item, key) in getOilCompanyBreakdown(scope.row)"
                      :key="key"
                      style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center; width: 100%; margin-bottom: 4px;"
                    >
                      <div class="iconBackground" style="margin-right: 10px; width: 24px; height: 24px; padding: 2px;" :class="item.key">
                        <div class="oilcompanyIconBackground">
                          <img class="oilcompanyIcon" :src="item.icon" :style="item.style"/>
                        </div>
                      </div>
                      <span style="word-break: break-word;">{{ item.value | formatDecimal }}</span>
                    </div>
                    <span v-if="getOilCompanyBreakdown(scope.row).length === 0">-</span>
                  </template>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="registerForm.quotaAdditionFlag"
              prop="vehicleQuotaAddition"
              label="Kuota Tambahan (Liter)"
              width="160"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span style="word-break: break-word;">{{ scope.row.vehicleQuotaAddition | formatNumber }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="vehicleQuotaFinal"
              label="Kuota Semasa (Liter)"
              width="180"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span v-if="!registerForm.fleetcardSubmittedFlagEhailing || getVehicleStatusValue(scope.row) === false" style="word-break: break-word;">0</span>
                  <span v-else-if="scope.row.vehiclebodytypeId && scope.row.vehiclebodytypeId.bodytypeSector && scope.row.vehiclebodytypeId.bodytypeSector === 'barangan' && (!revealBaranganQuota || (hideBorneolabuanBaranganQuota && isTrioDeclarationArea(scope.row)))">-</span>
                  <span v-else style="word-break: break-word;">{{ scope.row.vehicleQuotaCurrent | formatNumber }}</span>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="rayuan"
              label="Rayuan"
              width="180"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <template v-if="scope.row.vehicleRayuanAskedFlag">
                    <span style="color: #079d72;" v-if="scope.row.vehicleRayuanStatus === 'approved'">
                      Rayuan Diluluskan
                    </span>
                    <span style="color: var(--darker-border-color);" v-else-if="scope.row.vehicleRayuanStatus === 'processing'">
                      Rayuan Dalam Semakan
                    </span>
                    <span style="color: #bd4b4b;" v-else-if="scope.row.vehicleRayuanStatus === 'rejected'">
                      Rayuan Ditolakkan <br/>
                    </span>
                  </template>
                  <el-button type="primary smaller" @click="()=>userCreateRayuanDialog(scope.$index, scope.row)" v-else>
                    <i class="el-icon-plus" style="margin-right: 5px;"/> Rayuan
                  </el-button>
                </div>
              </template>
            </el-table-column> -->
            </el-table>
            <template
              v-if="registerForm && registerForm.fleetcardSubmittedFlagEhailing"
            >
              <p class="el-input-size" style="color: #cc0000">**Tekan butang Surat Kelulusan dan Senarai Kenderaan bagi menjana dokumen-dokumen anda.</p>
              <div
                style="display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start; width: 100%; margin-top: 15px;"
              >
                <el-button
                  type="primary"
                  :disabled="tableSection.vehicles.length === 0"
                  @click="printSuratKelulusan(tableSection.key)"
                >
                  Surat Kelulusan
                </el-button>
                <el-button
                  type="primary"
                  :disabled="tableSection.vehicles.length === 0"
                  @click="printSuratSenaraiKenderaan(tableSection.key)"
                >
                  Senarai Kenderaan
                </el-button>
              </div>
            </template>
          </div>
          <!-- <div v-if="canRecallVehicles && registerForm" style="margin-top: 20px;">
            <el-button
              type="warning"
              :loading="recallLoading"
              :disabled="recallLoading"
              @click="triggerVehicleRecall"
            >
              <i class="el-icon-refresh" style="margin-right: 5px;"/> Muat Semula Senarai
            </el-button>
          </div> -->
        </div>
      </div>
    </div>
    <el-dialog
      title="Ulasan"
      :visible.sync="userReadMore"
      :before-close="resetForm">
      <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: center;">
        <span style="margin-bottom: 5px;">{{ currentCompanyName }}</span>
        <span style="font-weight: bold; font-size: 24px; color: #000;">{{ currentVehicleNumber }}</span>
        <span class="readMoreRemarks">{{ currentRemarks }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="secondary" @click="resetForm">Tutup</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="Rayuan Kenderaan"
      :visible.sync="userRayuan"
      :before-close="resetForm">
      <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: center; margin-top: 20px;">
        <span style="margin-bottom: 5px;">{{ currentCompanyName }}</span>
        <span style="font-weight: bold; font-size: 24px; color: #000;">{{ currentVehicleNumber }}</span>
        <span style="margin: 20px 0px 10px 0px; text-align: center;"><span style="color: #bd4b4b;">*</span> Sila menyatakan alasan untuk rayuan kenderaan anda di bawah:</span>
        <el-form style="width: 100%;">
          <el-form-item required>
            <el-input
              type="textarea"
              v-model="userRayuanRemarks" 
              placeholder="Sila menyatakan alasan anda"
              :rows="4"
              style="width: 100%;"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="secondary" @click="resetForm">Batal</el-button>
        <el-button type="primary" @click="onSubmitRayuan" :disabled="checkSubmitRayuanDisabled">Hantar</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  activeTickFleetCardVehicles,
  personalExcelFleetCardVehicles
} from "@/api/ehailing/ehailingFleetCardVehicles";
import { targetVehicleRecallByUser } from "@/api/oldsystem";
import moment from 'moment'
import suratkelulusanawam from '../suratkelulusanawam'
import suratsenaraikenderaan from '../suratsenaraikenderaan'
export default {
  name: 'vehicle-new',
  inheritAttrs: false,
  data() {
    return {
      faqQuestionOpened: false,
      currentMonth: null,
      userReadMore: false,
      userRayuan: false,
      userRayuanRemarks: '',
      currentCompanyName: '',
      currentVehicleNumber: '',
      currentRemarks: '',
      checkboxLoading: false,
      submitRayuanDisabled: true,
      recallLoading: false,
    }
  },
  methods: {
    resetForm() {
      this.userReadMore = false
      this.currentCompanyName = ''
      this.currentVehicleNumber = ''
      this.currentRemarks = ''
      this.userRayuan = false
      // this.userRayuanRemarks = ''
    },
    openFaqQuestion() {
      this.faqQuestionOpened = !this.faqQuestionOpened
    },
    rowClick(row, column) {
      // if (column.label !== '#' && column.label !== 'Tindakan') {
      //   row.vehicleActiveTickedFlag = row.vehicleActiveTickedFlag === true ? false : true
      // }
    },
    async personalExcel() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let resp = await personalExcelFleetCardVehicles(this.$store.state.app.branchSelected, this.registerForm.branchIdEhailing)
        var link = document.createElement('a')
        link.href = URL.createObjectURL(new Blob([resp]))
        var fileName = `Senarai Kenderaan-${moment().unix()}.xlsx`
        link.download = fileName
        link.click()
      } catch (err) {
        console.log("download excel", err)
      }
      loading.close()
    },
    async selectAll() {
      this.checkboxLoading = true
      const allChecked = this.vehicleArray.every((item) => {
        const firstFlag = this.getVehicleStatusValue(item) === false ? true : false
        const secondFlag = !firstFlag ? item.vehicleActiveTickedFlag === true ? true : false : true
        return secondFlag
      })
      if (allChecked === true && this.registerForm.fleetcardSubmittedFlagEhailing) {
        this.checkboxLoading = false
        return
      }
      await this.vehicleArray.forEach(async (item) => {
        if (this.getVehicleStatusValue(item) === true) {
          item.vehicleActiveTickedFlag = !allChecked;
          try {
            await this.toggleVehicleTicked(item, false);
          } catch (err) {
            console.log("err", err)
          }
        }
      })
      if (!allChecked) {
        this.$message({
          message: 'Kenderaan telah diaktifkan',
          type: 'success'
        })
      } else {
        this.$message({
          message: 'Kenderaan telah dinyahaktifkan',
          type: 'success'
        })
      }
      this.checkboxLoading = false
    },
    async toggleVehicleTicked(row, promptMessage) {
      if (promptMessage) {
        this.checkboxLoading = true
      }
      try {
        const awamDiffer = row.vehiclebodytypeId && row.vehiclebodytypeId.bodytypeSector === 'awam' && (this.profileVehicleType === 'barangan' || this.profileVehicleType === '') ? true : false
        const baranganDiffer = row.vehiclebodytypeId && row.vehiclebodytypeId.bodytypeSector === 'barangan' && (this.profileVehicleType === 'awam' || this.profileVehicleType === '') ? true : false
        const payload = {
          vehicleActiveTickedFlag: row.vehicleActiveTickedFlag
        }
        await activeTickFleetCardVehicles(this.$store.state.app.branchSelected, row._id, payload)
        if (row.vehicleActiveTickedFlag) {
          if (promptMessage) {
            this.$message({
              message: 'Kenderaan telah diaktifkan',
              type: 'success'
            })
            this.checkboxLoading = false
          }

          // If Awam & Barangan are separate
          if ((awamDiffer || baranganDiffer) && this.registerForm.fleetcardSubmittedFlagEhailing) {
            // Call parent method to fetch selection oil company array
            // this.$emit('fetchSelectionOilCompanyArray', row._id);
            this.$emit('refreshProfileVehicleType');
          }
        } else {
          if (promptMessage) {
            this.$message({
              message: 'Kenderaan telah dinyahaktifkan',
              type: 'success'
            })
            this.checkboxLoading = false
          }
        }
        // }
      } catch (err) {
        if (promptMessage) {
          this.checkboxLoading = false
        }
        console.log("err", err)
      }
    },
    getVehicleStatusLabel(row) {
      const vehicleValidBodyFlag = row.vehicleValidBodyFlag ? true : false
      const vehicleValidModelFlag = row.vehicleValidModelFlag ? true : false
      const vehicleRoadTaxPassedFlag = row.vehicleRoadTaxPassedFlag ? true : false
      const vehicleActiveTickedFlag = row.vehicleActiveTickedFlag ? true : false
      const vehicleFinalQuotaValidFlag = row.vehicleFinalQuotaValidFlag ? true : false
      const vehicleAppealQuotaValidFlag = row.vehicleAppealQuotaValidFlag ? true : false

      if (vehicleAppealQuotaValidFlag) {
        return "RAYUAN LULUS"
      }
      if (!vehicleValidBodyFlag) {
        return "JENIS BADAN TIDAK LAYAK"
      }
      if (!vehicleValidModelFlag) {
        return "KELAS KEGUNAAN TIDAK LAYAK"
      }
      if (vehicleRoadTaxPassedFlag) {
        return "TAMAT CUKAI JALAN"
      }
      return "KENDERAAN LAYAK"
    },
    getVehicleStatusValue(row) {
      const vehicleValidBodyFlag = row.vehicleValidBodyFlag ? true : false
      const vehicleValidModelFlag = row.vehicleValidModelFlag ? true : false
      const vehicleRoadTaxPassedFlag = row.vehicleRoadTaxPassedFlag ? true : false
      const vehicleActiveTickedFlag = row.vehicleActiveTickedFlag ? true : false
      const vehicleFinalQuotaValidFlag = row.vehicleFinalQuotaValidFlag ? true : false
      const vehicleAppealQuotaValidFlag = row.vehicleAppealQuotaValidFlag ? true : false

      if (vehicleAppealQuotaValidFlag) {
        return true
      }
      if (!vehicleValidBodyFlag || !vehicleValidModelFlag || vehicleRoadTaxPassedFlag) {
        return false
      }
      return true
    },
    async navigateToWebPage(webpage) {
      this.$router.push(`/z/${this.$store.state.app.branchSelected}/ehailing/${webpage}`)
    },
    getRowClassName({ row, rowIndex }) {
      if (row.vehicleActiveTickedFlag) {
        return 'submitted-ticked-row'
      }
      return ''
    },
    readMoreDialog(row) {
      this.userReadMore = true
      if (this.registerForm) {
        this.currentCompanyName = this.registerForm.userGeneralName ? this.registerForm.userGeneralName : this.registerForm.userCompanyName
      }
      this.currentVehicleNumber = row.vehicleNumber
      this.currentRemarks = row.vehicleAppealRemarks
    },
    userCreateRayuanDialog(index, row) {
      this.userRayuan = true
      this.currentCompanyName = this.registerForm.userGeneralName ? this.registerForm.userGeneralName : this.registerForm.userCompanyName
      this.currentVehicleNumber = row.vehicleNumber
    },
    async triggerVehicleRecall() {
      this.recallLoading = true
      try {
        await targetVehicleRecallByUser(this.$store.state.app.branchSelected, { profileId: this.registerForm._id })
        this.$message({ message: 'Kenderaan berjaya dikemas kini', type: 'success' })
        this.$emit('refreshVehicles')
      } catch (err) {
        console.log('vehicle recall error', err)
        this.$message({ message: 'Ralat semasa kemas kini kenderaan', type: 'error' })
      }
      this.recallLoading = false
    },
    async onSubmitRayuan() {
      this.userRayuan = false
      this.userRayuanRemarks = ''

      try {
        this.$message({
          message: 'Rayuan kenderaan berjaya dihantar',
          type: 'success'
        })
      } catch (err) {
        console.log("err", err)
      }
    },
    getOilCompanyKeyByName(oilcompanyName) {
      switch (oilcompanyName) {
        case 'BHP': {
          return 'bhp'
        }
        case 'CALTEX (CHEVRON)': {
          return 'caltex'
        }
        case 'FIVE': {
          return 'five'
        }
        case 'PETRON MALAYSIA': {
          return 'petron'
        }
        case 'PETRONAS': {
          return 'petronas'
        }
        case 'SHELL': {
          return 'shell'
        }
      }
      return null
    },
    getOilCompanyIconByName(oilcompanyName) {
      switch (oilcompanyName) {
        case 'BHP': {
          return require('@/assets/bhplogo.png')
        }
        case 'CALTEX (CHEVRON)': {
          return require('@/assets/caltexlogo.png')
        }
        case 'FIVE': {
          return require('@/assets/fivelogo.png')
        }
        case 'PETRON MALAYSIA': {
          return require('@/assets/petronlogo.png')
        }
        case 'PETRONAS': {
          return require('@/assets/petronaslogo.png')
        }
        case 'SHELL': {
          return require('@/assets/shelllogo.svg')
        }
      }
      return null
    },
    getOilCompanyStyleByName(oilcompanyName) {
      switch (oilcompanyName) {
        case 'BHP': {
          return {
            width: '16px',
            height: '16px',
          }
        }
        case 'CALTEX (CHEVRON)': {
          return {
            width: '14px',
            height: '14px',
          }
        }
        case 'FIVE': {
          return {
            width: '16px',
            height: '16px',
          }
        }
        case 'PETRON MALAYSIA': {
          return {
            width: '14px',
            height: '14px',
          }
        }
        case 'PETRONAS': {
          return {
            width: '12px',
            height: '12px',
          }
        }
        case 'SHELL': {
          return {
            width: '16px',
            height: '16px',
          }
        }
      }
      return {
        width: '16px',
        height: '16px',
      }
    },
    getOilCompanyBreakdown(row) {
      const companies = this.awamOilcompanyArray
      if (!companies.length) {
        return []
      }
      const base = Number(row.vehicleQuotaBase) || 0
      const totalPercentage = companies.reduce((acc, company) => acc + (Number(company.oilcompanyPercentage) || 0), 0)
      const roundOneDecimal = (value) => Math.round(value * 10) / 10
      const values = companies.map((company) => {
        const percentage = Number(company.oilcompanyPercentage) || 0
        return roundOneDecimal(base * percentage / 100)
      })
      // Fold any rounding remainder into the last oil company so the breakdown sums to the full base
      const desiredTotal = roundOneDecimal(base * totalPercentage / 100)
      const currentTotal = roundOneDecimal(values.reduce((acc, value) => acc + value, 0))
      const remainder = roundOneDecimal(desiredTotal - currentTotal)
      if (remainder !== 0) {
        const lastIndex = values.length - 1
        values[lastIndex] = roundOneDecimal(values[lastIndex] + remainder)
      }
      return companies.map((company, index) => ({
        name: company.oilcompanyName,
        key: this.getOilCompanyKeyByName(company.oilcompanyName),
        icon: this.getOilCompanyIconByName(company.oilcompanyName),
        style: this.getOilCompanyStyleByName(company.oilcompanyName),
        value: values[index]
      }))
    },
    normalizeDeclarationArea(value) {
      return value ? String(value).trim().toUpperCase() : ''
    },
    isTrioDeclarationArea(row) {
      const area = this.normalizeDeclarationArea(row && row.vehicleDeclarationArea)
      return area === 'SABAH' || area === 'SARAWAK' || area === 'LABUAN' || area === 'WILAYAH PERSEKUTUAN LABUAN'
    },
    getVehiclesByDeclarationGroup(group = 'normal') {
      if (this.combineTrioWithDefault) {
        return group === 'trio' ? [] : this.sourceVehicleArray
      }
      const isTrioGroup = group === 'trio'
      return this.sourceVehicleArray.filter((vehicle) => this.isTrioDeclarationArea(vehicle) === isTrioGroup)
    },
    getPrintableVehiclesByDeclarationGroup(group = 'normal') {
      const now = moment()
      return this.getVehiclesByDeclarationGroup(group).filter((vehicle) => {
        return vehicle.vehicleActiveTickedFlag == true && now.isBefore(vehicle.vehicleRoadTaxEndDate) && !vehicle.vehicleRestrictionFlag
      }).map((vehicle) => {
        return {
          ...vehicle,
          vehicleRoadTaxEndDate: moment(vehicle.vehicleRoadTaxEndDate).format('DD/MM/YYYY'),
        }
      })
    },
    getNextMonthYearLabel() {
      const newTime = moment().clone().add(1, 'months')
      const month = newTime.month()
      const year = newTime.year()
      let monthLabel = ''
      switch (month) {
        case 0:
          monthLabel = 'JANUARI'
          break
        case 1:
          monthLabel = 'FEBRUARI'
          break
        case 2:
          monthLabel = 'MAC'
          break
        case 3:
          monthLabel = 'APRIL'
          break
        case 4:
          monthLabel = 'MEI'
          break
        case 5:
          monthLabel = 'JUN'
          break
        case 6:
          monthLabel = 'JULAI'
          break
        case 7:
          monthLabel = 'OGOS'
          break
        case 8:
          monthLabel = 'SEPTEMBER'
          break
        case 9:
          monthLabel = 'OKTOBER'
          break
        case 10:
          monthLabel = 'NOVEMBER'
          break
        case 11:
          monthLabel = 'DISEMBER'
          break
      }
      return monthLabel + ' ' + year
    },
    printDocument(content) {
      let printWindow = window.open('', '_blank');
      printWindow.document.open();
      printWindow.document.write(content);
      printWindow.document.close();
      printWindow.onload = function () {
        const img = printWindow.document.getElementById('letterhead');
        if (img.complete) {
          printWindow.print();
        } else {
          img.onload = function () {
              printWindow.print();
          };
          img.onerror = function () {
              alert('Failed to load image.');
          };
        }
      };
    },
    printSuratKelulusan(group) {
      if (this.$listeners && this.$listeners.printSuratKelulusan) {
        this.$emit('printSuratKelulusan', group)
        return
      }
      const declarationGroup = this.combineTrioWithDefault ? 'normal' : group
      const now = moment()
      const dateFormatted = now.format('DD/MM/YYYY')
      const nextMonth = now.clone().add(1, 'days').add(1, 'months').set({
        date: 1,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
      }).format('DD/MM/YYYY')
      const suratKelulusanModule = suratkelulusanawam
      const content = suratKelulusanModule.content(
        this.registerForm,
        this.getPrintableVehiclesByDeclarationGroup(declarationGroup),
        this.oilcompanyArray,
        dateFormatted,
        nextMonth,
        false
      )
      this.printDocument(content)
    },
    printSuratSenaraiKenderaan(group) {
      if (this.$listeners && this.$listeners.printSuratSenaraiKenderaan) {
        this.$emit('printSuratSenaraiKenderaan', group)
        return
      }
      const declarationGroup = this.combineTrioWithDefault ? 'normal' : group
      const now = moment()
      const groupVehicleArray = this.getPrintableVehiclesByDeclarationGroup(declarationGroup)
      const vehicleListA = groupVehicleArray.filter((vehicle) => {
        const sector = vehicle.vehiclebodytypeId && vehicle.vehiclebodytypeId.bodytypeSector ? vehicle.vehiclebodytypeId.bodytypeSector : vehicle.vehicleBodyTypeSector
        return sector === 'awam'
      })
      const vehicleListB = groupVehicleArray.filter((vehicle) => {
        const sector = vehicle.vehiclebodytypeId && vehicle.vehiclebodytypeId.bodytypeSector ? vehicle.vehiclebodytypeId.bodytypeSector : vehicle.vehicleBodyTypeSector
        return sector === 'barangan'
      })
      const suratSenaraiModule = suratsenaraikenderaan
      const content = suratSenaraiModule.content(
        this.registerForm,
        vehicleListA,
        vehicleListB,
        this.oilcompanyArray,
        now.format('DD/MM/YYYY'),
        this.getNextMonthYearLabel()
      )
      this.printDocument(content)
    },
  },
  props: {
    titleFaqQuestion: {
      type: String
    },
    descFaqQuestion: {
      type: String
    },
    tajukKad: {
      type: String
    },
    vehicleArray: {
      type: Array,
      default: () => []
    },
    oilcompanyArray: {
      type: Array,
      default: () => []
    },
    searchKenderaan: {
      type: String
    },
    handleVehicleDelete: {
      type: Function
    },
    saveAndNavigate: {
      type: Function
    },
    viewRayuan: {
      type: Function
    },
    profileVehicleType: {
      type: String
    },
    locked: {
      type: Boolean
    },
    tickedless: {
      type: Boolean
    },
    rayuanless: {
      type: Boolean
    },
    registerForm: {
      type: Object
    },
    revealBaranganQuota: {
      type: Boolean
    },
    hideBorneolabuanBaranganQuota: {
      type: Boolean,
      default: false
    },
    combineTrioWithDefault: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean
    }
  },
  filters: {
    formatProfileVehicleType(val) {
      switch (val) {
        case 'awambarangan': return 'AWAM & BARANGAN'
        case 'awam': return 'AWAM'
        case 'barangan': return 'BARANGAN'
        default: return '-'
      }
    },
    formatDateTime(val) {
      if (val !== undefined) {
        return moment.unix(Number(val)).format('DD/MM/YYYY HH:mm')
      }
      return ''
    },
    formatDate(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      }
      return '-'
    },
    formatNumber(val) {
      if (val !== null && val !== undefined) {
        return val.toLocaleString('en')
      }
      return '-'
    },
    formatDecimal(val) {
      if (val !== null && val !== undefined) {
        return Number(val).toLocaleString('en', { maximumFractionDigits: 1 })
      }
      return '-'
    },
  },
  computed: {
    relationRole() {
      return this.$store.state.user.branchData && this.$store.state.user.branchData.relation ? this.$store.state.user.branchData.relation.role : null
    },
    canRecallVehicles() {
      return ['kpdnadmin', 'enforcer', 'callcenteruser', 'callcentersupervisor', 'stateuser', 'cawanganuser', 'cawanganmanager', 'kpdnrolemanager', 'bpmuser', 'bpmmanager'].includes(this.relationRole)
    },
    awamOilcompanyArray() {
      return Array.isArray(this.oilcompanyArray) ? this.oilcompanyArray.filter((oilcompany) => oilcompany.oilcompanyProfileVehicleType === 'awam') : []
    },
    sourceVehicleArray() {
      return Array.isArray(this.vehicleArray) ? this.vehicleArray : []
    },
    normalVehicleArray() {
      return this.sourceVehicleArray.filter((vehicle) => !this.isTrioDeclarationArea(vehicle))
    },
    trioVehicleArray() {
      return this.sourceVehicleArray.filter((vehicle) => this.isTrioDeclarationArea(vehicle))
    },
    hasTrioVehicles() {
      return this.trioVehicleArray.length > 0
    },
    vehicleTableSections() {
      if (this.combineTrioWithDefault) {
        return [
          {
            key: 'normal',
            title: '',
            showTitle: false,
            vehicles: this.sourceVehicleArray
          }
        ]
      }
      const sections = []
      if (this.normalVehicleArray.length > 0 || !this.hasTrioVehicles) {
        sections.push({
          key: 'normal',
          title: '',
          showTitle: false,
          vehicles: this.normalVehicleArray
        })
      }
      if (this.hasTrioVehicles) {
        sections.push({
          key: 'trio',
          title: 'Senarai Kenderaan Sabah, Labuan dan Sarawak',
          showTitle: true,
          vehicles: this.trioVehicleArray
        })
      }
      return sections
    },
    kenderaanKuotaAsa() {
      return Number(this.vehicleArray.filter(item => item.vehicleActiveTickedFlag).reduce((acc, item) => {
        const value = Number(item.vehicleQuotaFinal) ? Number(item.vehicleQuotaFinal) : 0
        return acc + value
      }, 0)).toLocaleString('en')
    },
    kenderaanKuotaSemasa() {
      return Number(this.vehicleArray.reduce((acc, item) => {
        const value = Number(item.vehicleQuotaCurrent) ? Number(item.vehicleQuotaCurrent) : 0
        return acc + value
      }, 0)).toLocaleString('en')
    },
    currentMonthLabel() {
      switch (this.currentMonth) {
        case '01': return 'JANUARI'
        case '02': return 'FEBRUARI'
        case '03': return 'MAC'
        case '04': return 'APRIL'
        case '05': return 'MEI'
        case '06': return 'JUN'
        case '07': return 'JULAI'
        case '08': return 'OGOS'
        case '09': return 'SEPTEMBER'
        case '10': return 'OKTOBER'
        case '11': return 'NOVEMBER'
        case '12': return 'DISEMBER'
      }
    },
    checkSubmitRayuanDisabled() {
      if (this.userRayuanRemarks.trim() === '') {
        return true
      } else {
        return false
      }
    },
  },
  mounted() {
    this.currentMonth = moment().format('MM')
  }
}
</script>

<style scoped>
.submitted-ticked-row {
  background-color: #ffe6e6 !important;
}

.submitted-ticked-row:hover {
  background-color: #ffcccc !important;
}
</style>


// WEBPACK FOOTER //
// src/views/ehailing/components/VehicleNewEhailing.vue